'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extend = require('@souche-f2e/extend');

var _extend2 = _interopRequireDefault(_extend);

var _gaode = require('./gaode');

var _gaode2 = _interopRequireDefault(_gaode);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;
// 初始化配置数据
var initData = {
    cache: true, // 是否使用缓存
    timeout: 20000, // 默认超时时间20s
    province: false, // 是否获取省份名称
    gaode: '49ea68e9da3980a8b11a5ed4127752f6'
};
// 启用缓存时，缓存数据
var positionData = null;
// 放在sessionStorage 中的缓存key
var POSITION_KEY = 'cache_vue_position';

var ValidLoad = function ValidLoad() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // 如果是服务端渲染，则不走分享的逻辑
    if (params.isServer) {
        return;
    }
    if (typeof params.load === 'function' && !params.load()) {
        return;
    }
    if (params.load === false) {
        return;
    }
    return true;
};

var startGetPosition = function startGetPosition() {
    if (window.Tower && window.Tower.app) {
        return window.Tower.getGPSNew().catch(function () {
            return Promise.reject({
                success: false,
                msg: '从app中获取地理位置信息失败',
                code: 700
            });
        });
    }
    return _gaode2.default.getPosition();
};
// 分享方法
var getPosition = function getPosition() {
    return new Promise(function (resolve, reject) {
        if (!ValidLoad(_utils2.default.configData)) {
            reject({
                success: false,
                msg: '未授权',
                code: 400
            });
        } else {
            // 有缓存先走缓存
            if (_utils2.default.configData.cache && positionData) {
                resolve(positionData);
            }
            startGetPosition().then(function (data) {
                try {
                    _utils2.default.configData.cache && sessionStorage.setItem(POSITION_KEY, (0, _stringify2.default)(data));
                } catch (e) {
                    // TODO 浏览器不支持缓存的情况
                }
                resolve(data);
            }).catch(function (err) {
                reject(err);
            });
            // 超时操作
            if (_utils2.default.configData.timeout) {
                setTimeout(function () {
                    reject({
                        success: false,
                        msg: '定位失败',
                        reason: 'TIMEOUT',
                        code: 300
                    });
                }, _utils2.default.configData.timeout);
            }
        }
    });
};

var initCache = function initCache() {
    // 如果有缓存的话
    if (_utils2.default.configData.cache) {
        try {
            positionData = sessionStorage.getItem(POSITION_KEY);
        } catch (e) {
            positionData = null;
        }
        if (positionData) {
            try {
                positionData = JSON.parse(positionData);
            } catch (e) {
                positionData = null;
            }
        }
    }
};

exports.default = {
    install: function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        Vue.prototype.$getPosition = getPosition;
        if (!ValidLoad(options)) {
            return;
        }
        // 执行初始化操作
        _utils2.default.configData = (0, _extend2.default)(initData, options);
        initCache();
    },

    getPosition: getPosition
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-vue/vue-position/dist/index.js
// module id = 290
// module chunks = 4